let stateLazy = false;
function dataLazyEffect() {
	if(window.innerWidth < 639 && !stateLazy) {
		const callback = function(entries, observer) {
			$(entries).each((index, entry) => {
				if(entry.intersectionRatio > 0) {
					console.log(entry);
					$(entry.target).addClass('show');
				}
			});
		};

		const observer = new IntersectionObserver(callback);

		$('[data-lazy-effect]').each((index, element) => {
			// console.log(element);
			observer.observe(element);
		});
		stateLazy = true;
	}
}
dataLazyEffect();
window.addEventListener('resize', function () {
	dataLazyEffect();
});



// WEBPACK FOOTER //
// ./libs/data-lazy-effect/index.js